function VuiCopyright() {
  return (
    <div className="w-full text-center text-xs text-darkGray">
      Copyright 2023 &copy; Vui App
    </div>
  );
}

export default VuiCopyright;
